import { Text } from '@mantine/core';
import { getTimePassedText } from '@/utils/dateTimeUtils';

export function CreatedAtInfoBadge({ createdAt }: { createdAt: string }) {
  return <Text>{getTimePassedText(createdAt)}</Text>;
}
